<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><strong>P<span class="small">LEASE</span> D<span class="small">ON’T</span> W<span class="small">ISH</span> M<span class="small">E A</span> M<span class="small">ERRY</span> C<span class="small">HRISTMAS</span></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?5b2300e5